import React from 'react';
import { List, Row, Col, Modal, Button } from 'antd';
import _ from "lodash";
import Spinner from '../../spinner/spinner';
import { graphql, compose } from 'react-apollo';
import { getDailyScriptures } from "./queries/getDailyScriptures";
import { deleteDailyScripture } from "./mutations/deleteDailyScripture";
import { EditButton } from "../../common/editButton/editButton";
import { DeleteButton } from "../../common/deleteButton/deleteButton";
import { revivalPhases } from "./dailyScripturesForm";
import "./dailyScripturesList.css";

const PAGE_SIZE = 10;

class DailyScripturesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.stateObject;
  }

  get stateObject() {
    const query = new URLSearchParams(this.props.history.location.search);
    const page = parseInt(query.get('page'), 10);
    if (page) {
      return { currentPage: page, startPageItem: (page - 1) * PAGE_SIZE, endPageItem: page * PAGE_SIZE };
    } else {
      return { currentPage: 1, startPageItem: 0, endPageItem: PAGE_SIZE };
    }
  }

  get pagination() {
    return {
      total: this.props.data.dailyScriptures.length,
      pageSize: PAGE_SIZE,
      current: this.state.currentPage,
      onChange: this.onChange
    }
  }

  get dataSource() {
    return this.props.data.dailyScriptures.slice(this.state.startPageItem, this.state.endPageItem);
  }

  resolveScriptureType = (scripture) => {
    return _.find(revivalPhases, (revivalPhase) => {
      return revivalPhase.value === scripture.type_value;
    }).text;
  }

  scriptureTitle(scripture) {
    return (
      <Row type="flex">
        <Col md={{ span: 20, order: 0 }} xs={{ span: 24, order: 1 }}>
          {scripture.type && <p>Day {scripture.day} of {this.resolveScriptureType(scripture)}</p>}
          <p className="daily-scriptures-list__headline">{scripture.headline}</p>
        </Col>
        <Col md={{ span: 3, offset: 0 }} xs={{ span: 6 }} className="daily-scriptures-list-edit-link">
          <EditButton link={`/dashboard/admin/scripturesList/updateScripture/${scripture.id}`} className="myclass"/>
        </Col>
        <Col md={{ span: 1 }} xs={{ span: 2 }}>
          <DeleteButton onClick={() => { this.onRemove(scripture) }}/>
        </Col>
      </Row>
    )
  }

  findPageByScriptureId() {
    const query = new URLSearchParams(this.props.history.location.search);
    const scriptureId = parseInt(query.get('scripture'), 10);
    if (scriptureId) {
      const page = Math.ceil((this.props.data.dailyScriptures.findIndex((scripture) => scripture.id === scriptureId) + 1) / PAGE_SIZE);
      this.props.history.replace(`?page=${page}`);
    }
  }

  onChange = (page) => {
    this.props.history.push(`?page=${page}`);
  };

  mutationParams(scriptureId) {
    return {
      variables: {
        input: {
          id: scriptureId
        }
      }
    };
  }

  async submitData(scriptureId) {
    try {
      this.setState({ loading: true });
      await this.props.mutate(this.mutationParams(scriptureId));
      window.location.reload();
    }
    finally {
      this.setState({ loading: false });
    }
  }

  onRemove = (scripture) => {
    Modal.confirm({
      title: `Are you sure you want to remove ${scripture.headline}?`,
      width: 510,
      okText: 'Remove',
      onOk: () => { this.submitData(scripture.id) }
    });
  };

  render() {
    if (this.props.data.loading) {
      return <Spinner/>;
    } else {
      this.findPageByScriptureId();
      return (
        <div>
          <div className="dashboard-layout__placeholder"/>
          <div className="m-24">
            <List
              itemLayout="vertical"
              size="large"
              pagination={this.pagination}
              dataSource={this.dataSource}
              renderItem={scripture => (
                <Row>
                  <List.Item key={scripture.id} extra={<img className="daily-scriptures-list__image" width={272} alt="logo" src={scripture.image.default} />}>
                    <List.Item.Meta title={this.scriptureTitle(scripture)} description={scripture.text}/>
                    {scripture.comment}
                  </List.Item>
                </Row>
              )}
            />
          </div>
        </div>
      );
    }
  }
}

export default compose(
  graphql(getDailyScriptures, {
    options: { fetchPolicy: 'network-only' }
  }),
  graphql(deleteDailyScripture)
)(DailyScripturesList);



// WEBPACK FOOTER //
// ./src/components/pages/dailyScriptures/dailyScripturesList.js